import axios from './axios'
import { getDateRequest } from '../utils/dateRequest.js'

export async function getObjetivos(type){
  return await axios.get(`configuracao?acao=objetivos&tipo=${type}${getDateRequest()}`, {})
}